import { useEffect } from 'react';

import { getWorldLine2FromLatLngArray } from '../../helpers/getWorldLine2FromLatLngArray';
import { useMRE } from '../../hooks/useMRE';
import { LatLng } from '../../types';

interface SegmentProps {
  id: string;
  segmentPolyline?: LatLng[];
  name?: string | null;
}

/*
 * This component renders a segment on a map, e.g. RDP
 */
export const Segment = ({ id, segmentPolyline, name }: SegmentProps) => {
  const { terrainEngine } = useMRE();

  useEffect(() => {
    if (!segmentPolyline || !terrainEngine) {
      return;
    }

    if (segmentPolyline.length < 2) {
      // The MRE's `displayLiveSegments()` function will crash with error "segment must have more than one point"
      // if this condition is not met.
      return;
    }

    // the highlighted segment
    const segmentId = `${id}-segment`;

    // HACK: `.getRecordContent().displayLiveSegments()` is designed for displaying "live segments" within
    // mobile record. We are using it here because, right now, it also looks good and works well in RDP.
    // However, if the product requirements for mobile record change, so magically will our web RDP experience.
    // Therefore, I consider this a HACK which adds fragility to our code and should be cleaned up some time.
    terrainEngine
      .getContent()
      .getRecordContent()
      .displayLiveSegments([
        {
          identifier: segmentId,
          isStarred: false,
          line: getWorldLine2FromLatLngArray(segmentPolyline),
          title: name || ''
        }
      ]);

    return () => {
      terrainEngine.getContent().getRecordContent().removeAllLiveSegments();
    };
  }, [terrainEngine, id, segmentPolyline, name]);

  return null;
};
